module.exports = __webpack_public_path__ + "media/images/mailer/star-48-white-8d588c3e3b3c20af8c8a395bfa51541a.png";